__turbopack_context__.v({
  "badge": "PerformanceHub-module__VXaNJq__badge",
  "bar": "PerformanceHub-module__VXaNJq__bar",
  "barWrap": "PerformanceHub-module__VXaNJq__barWrap",
  "card": "PerformanceHub-module__VXaNJq__card",
  "dot": "PerformanceHub-module__VXaNJq__dot",
  "eyebrow": "PerformanceHub-module__VXaNJq__eyebrow",
  "label": "PerformanceHub-module__VXaNJq__label",
  "metric": "PerformanceHub-module__VXaNJq__metric",
  "sentimentNegative": "PerformanceHub-module__VXaNJq__sentimentNegative",
  "sentimentNeutral": "PerformanceHub-module__VXaNJq__sentimentNeutral",
  "sentimentPositive": "PerformanceHub-module__VXaNJq__sentimentPositive",
  "sub": "PerformanceHub-module__VXaNJq__sub",
  "title": "PerformanceHub-module__VXaNJq__title",
});
